interface Node {
  undernoder: Node[];
}

export const getLeafNodes = <T extends Node>(nodes: T[]): T[] => {
  const leafNodes: T[] = [];
  for (const node of nodes) {
    if (isLeafNode(node)) {
      leafNodes.push(node);
    } else {
      leafNodes.push(...getLeafNodes(node.undernoder as T[]));
    }
  }
  return leafNodes;
};

export const isLeafNode = (node: Node) => {
  return node.undernoder.length === 0;
};
